import { useContext, useMemo } from 'react';

import { useQuery } from '@apollo/client';

import JoinWishListButton from './JoinWishListButton';
import LeaveWishListButton from './LeaveWishListButton';
import { Store } from '@website/Store';
import { FetchUserWishlistDocument } from '@website/types/graphqlOperations';


type WishlistToggleButtonProps = {
  tripId: string;
  isTripsPage?: boolean;
};

export default function WishlistToggleButton({
  tripId,
  isTripsPage = false,
}: WishlistToggleButtonProps) {
  const { state } = useContext(Store);

  const userID = state.user?.id;

  const { data, error, refetch } = useQuery(FetchUserWishlistDocument, {
    variables: {
      id: userID,
    },
    skip: !userID,
  });

  const userInWishlist = useMemo(() => {
    if (!data) {
      return false;
    }
    return data.user.wishlist.items.some((wishlistItem) => {
      return wishlistItem.trip.id === tripId;
    });
  }, [data, tripId]);

  if (error) {
    return null;
  }

  if (userInWishlist) {
    return (
      <LeaveWishListButton
        tripId={tripId}
        userId={userID}
        onSuccess={refetch}
        isTripsPage={isTripsPage}
      />
    );
  }

  return (
    <JoinWishListButton
      tripId={tripId}
      onSuccess={refetch}
      isTripsPage={isTripsPage}
    />
  );
}
